export const settingsSelector = (state) => state.settingsManagement;
